module.controller('transactionCtrl', ['$scope', '$state', '$stateParams', '$http', '$rootScope', 'cacheService', 'Transform', 'baseURI', 'TransactionService', 'OVERLAY', 'FileUploader', 'Session', function ($scope, $state, $stateParams, $http, $rootScope, cacheService, Transform, baseURI, TransactionService, OVERLAY, FileUploader, Session){
  var transaction = TransactionService.getById($stateParams.id);
  var transactionId = transaction.Id.split('.');

  transactionId = transactionId[1];
  $scope.overlay = OVERLAY['member.home.transaction'];
  $scope.child = {};
  $scope.transaction = transaction;
  $scope.overlay.title = (transaction.Status == 'pending' ? ('Pending ' + transaction.Title) : transaction.Title);
  $scope.overlay.icon = transaction.Icon;

  var getNextBatch = function(){
    var currentTime = moment();
    var currentDay = currentTime.day();
    var nextBatch = moment();
    nextBatch.utcOffset(-300);
    nextBatch.set('hour', 19);
    nextBatch.set('minute', 29);

    // is it monday or sunday
    if(currentDay === 0 || currentDay === 6){
      if(currentDay === 0){
        nextBatch.add(1, 'days');
      } else {
        nextBatch.add(2, 'days');
      }
    } else if(nextBatch.isBefore(currentTime)) {
      nextBatch.add(1, 'days');
    }
    return nextBatch.local();
  };

  var getPreviousBatch = function(){
    var currentTime = moment();
    var currentDay = currentTime.day();
    var previousBatch = moment();
    previousBatch.utcOffset(-300);
    previousBatch.set('hour', 19);
    previousBatch.set('minute', 29);

    // is it sunday or monday
    if(currentDay === 0 || currentDay === 1){
      if(currentDay === 0){
        previousBatch.subtract(2, 'days');
      } else {
        // is it monday past the batch time
        if(previousBatch.isAfter(currentTime))
          previousBatch.subtract(3, 'days');
      }
    } else if(previousBatch.isAfter(currentTime)) {
      previousBatch.subtract(1, 'days');
    }

    return previousBatch.local();
  };

  if(transaction.IsNotification){
    $scope.overlay.headerClass = ' ';
    switch (transaction.Type){
    case 'R1':
      $scope.showRemoveRequest = true;
      break;
    case 'R2':
      $scope.showFulfillRequest = true;
      $scope.showRemoveRequest = true;
      break;
    case '130':
      var created = moment(transaction.Time + '-06:00');

      var nextBatch = getNextBatch();
      var previousBatch = getPreviousBatch();
      if(created.isBefore(nextBatch) && created.isAfter(previousBatch)){
        $scope.showRemovePendingTransfer = true;
      }

      break;
    }
  } else {
    $scope.overlay.headerClass = (transaction.Amount > 0 ? 'overlay-alt-bkg' : 'overlay-alt-2-bkg');
    $scope.showAddMessage = true;
    $scope.showAddPhoto = true;
  }

  // Notifications that are fulfillable
  $scope.fulFillRequest = function(){
    $state.go('member.home.send/transfer.step2', {
      username: $scope.transaction.FromUsername,
      firstName: $scope.transaction.FromFirstName,
      lastName: $scope.transaction.FromLastName,
      amount: $scope.transaction.Amount,
      transId: transactionId
    });
  };

  // Notifications that are removable
  // endpoint: api endpoint to request
  $scope.removeRequest = function(endpoint){
    var req;
    var method;
    switch (endpoint){
    case 'request':
      req = { CardTransferId: transactionId };
      method = 'PUT';
      break;
    case 'bank/transfer':
      req = { };
      method = 'DELETE';
      endpoint += '/' + transactionId;
      break;
    case 'consumer-choice/paypal':
      req = { };
      method = 'DELETE';
      endpoint += '/' + transactionId;
      break;
    }
    
    $scope.loading = true;

    $http({
      url: baseURI + endpoint,
      method: method,
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode(req)
    }).then(function (resp){
      var data = resp.data;

      $scope.loading = false;
      cacheService.clear('transfer');
      $rootScope.back();
    }).catch(function(error){
      $scope.loading = false;
      $scope.showFooterError = true;
    });
  };

  $scope.addPhoto = function(){
    var file = document.getElementById('file').files[0];
    var reader = new FileReader();
    reader.onloadend = function(e){
      var fileData = e.target.result;
      updateTransaction({Photo: fileData});
    };
    reader.readAsArrayBuffer(file);
  };

  $scope.addMessage = function(message){
    $scope.child.showAddMessageOption = false;
    updateTransaction({Note: message});
  };

  $scope.child.uploadOptions = {
    formData: [{
      TransactionTypeId: transaction.Type,
      AuthId: '000',
      TransactionId: transaction.Id
    }],
    alias: 'Photo'
  };

  // photo upload options
  $scope.uploader = new FileUploader({
    url: baseURI + 'transactions',
    method: 'PUT',
    autoUpload: true,
    headers: {
      Authorization: 'Bearer ' + Session.getToken()
    }
  });

  $scope.uploader.onCompleteItem = function(item, response, status, header){
    if (response.Success) {
      cacheService.clear('feeds');
      $scope.transaction.Photo = "https://app.akimbocard.com/app/user/" + response.Data.Photo;
    }
  };


  // Send message/photo prop to update
  var updateTransaction = function(updateProp){
    var updateReq = {
      TransactionTypeId: transaction.Type,
      AuthId: '000',
      TransactionId: transaction.Id
    };

    updateReq = angular.extend(updateReq, updateProp);

    $http({
      url: baseURI + 'transactions',
      method: 'PUT',
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode(updateReq)
    }).then(function (resp){
      var data = resp.data;

      cacheService.clear('feeds');
      $scope.transaction.Note = data.Data.Note;
      if (data.Data.Photo) {
          $scope.transaction.Photo = "https://app.akimbocard.com/app/user/" + data.Data.Photo;
      }
    }).catch(function(error){
      console.log(error);
    });
  };
}]);
